import { consts } from './js/consts'
import BrandSubNavigation from '../sub-navigation/'

require('./index.css')

class BrandTopNavigation {
  constructor () {
    let isSpecMode = document.head.querySelector(`meta[name=${consts.BRAND_SPEC_RUN_MODE}]`) !== null
    if (isSpecMode) return
    const brandHeader = document.querySelector(`.${consts.BRAND_HEADER}`)
    const topLinksList = document.querySelectorAll(`.${consts.BRAND_NAVIGATION_TOP_MENU_LINK_EXPANDABLE}`)
    const burgerToggle = document.querySelectorAll(`.${consts.BRAND_NAVIGATION_TOP_MENU_BURGERTOGGLE}`)
    this.addVisibleToggleEvent(topLinksList)
    this.addVisibleCustomElementToggleEvent(burgerToggle)
    this.closeOnClickOutside(brandHeader)
    this.setGridPositionForDropdownColumns()
    this.brandSubNavigation = new BrandSubNavigation()
  }

  hideAllVisibleLinks (node) {
    let visibleLinks = node.querySelectorAll(`.${consts.BRAND_IS_VISIBLE}`)
    for (let i = 0; i < visibleLinks.length; i++) {
      visibleLinks[i].classList.remove(consts.BRAND_IS_VISIBLE)
    }
  }

  closeOnClickOutside (brandHeader) {
    if (!brandHeader) return

    window.addEventListener('click', (event) => {
      if (!brandHeader.contains(event.target)) {
        this.hideAllVisibleLinks(document.querySelector(`.${consts.BRAND_NAVIGATION_TOP_MENU}`))
      }
    })
  }

  disableBodyOverflow () {
    let body = document.querySelector('body')
    body.classList.toggle(consts.BRAND_NAVIGATION_NO_SCROLL)
  }

  addVisibleCustomElementToggleEvent (linkList) {
    for (let i = 0; i < linkList.length; i++) {
      linkList[i].addEventListener('click', (event) => {
        this.disableBodyOverflow()
        event.preventDefault()
        event.target.classList.toggle(consts.BRAND_IS_VISIBLE)
        let customElementTarget
        let customElementTargetClass = event.target.getAttribute('data-brand-toggle-target')
        if (customElementTargetClass) {
          customElementTarget = document.querySelectorAll(`.${customElementTargetClass}`)
        }
        if (customElementTarget) {
          for (let j = 0; j < customElementTarget.length; j++) {
            customElementTarget[j].classList.toggle(consts.BRAND_IS_VISIBLE)
          }
        }
      })
    }
  }

  addVisibleToggleEvent (linkList) {
    for (let link = 0; link < linkList.length; link++) {
      linkList[link].addEventListener('click', (event) => {
        event.preventDefault()
        let isVisible = event.target.classList.contains(consts.BRAND_IS_VISIBLE)
        this.hideAllVisibleLinks(event.target.parentNode.parentNode)
        if (isVisible) {
          event.target.classList.remove(consts.BRAND_IS_VISIBLE)
        } else {
          event.target.classList.add(consts.BRAND_IS_VISIBLE)
        }
      })
    }
  }

  setGridPositionForDropdownColumns () {
    let brandNavDropdown = document.querySelectorAll(`.${consts.BRAND_NAVIGATION_DROPDOWN_GRID}`)
    for (let i = 0; i < brandNavDropdown.length; i++) {
      let columnCounter = 1
      let dropdownSectionsAmount = brandNavDropdown[i].children.length
      for (let j = 0; j < dropdownSectionsAmount; j++) {
        columnCounter = (columnCounter > Math.round(dropdownSectionsAmount / 2)) ? 1 : columnCounter
        const row = (j < Math.round(dropdownSectionsAmount / 2)) ? 1 : 2
        brandNavDropdown[i].children[j].style.msGridRow = row
        brandNavDropdown[i].children[j].style.msGridColumn = columnCounter
        brandNavDropdown[i].children[j].style.gridRow = row
        brandNavDropdown[i].children[j].style.gridColumn = columnCounter++
      }
    }
  }
}

const init = () => {
  const brandNavigation = new BrandTopNavigation()
  if (!brandNavigation) {
    console.error('Loading navbar failed')
  }
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  init()
} else {
  document.addEventListener('DOMContentLoaded', () => {
    init()
  })
}



// WEBPACK FOOTER //
// ./src/components/top-navigation/index.js